import React, { Component } from 'react';
import { Redirect } from 'react-router-dom';
import PropTypes from 'prop-types';

// Redux
import { connect } from 'react-redux';

// Components
import HubForm from '../../../../components/HubForm';

// Constants
import { DEFAULT } from '../../../../constants';
import PageHeader from '../../../../components/PageHeader';

class AssignHub extends Component {
  constructor(props) {
    super(props);

    this.state = {
      redirectToHubs: false
    };
  }

  render() {
    return this.state.redirectToHubs || !this.props.setupMode ? <Redirect to='/admin/hubs' /> : (
      <>
        <PageHeader title='Hub Assignment' />
        <HubForm onSuccess={() => this.setState({ redirectToHubs: true })} />
      </>
    );
  }
}

const mapStateToProps = state => ({
  statusColor: state.status.schoolStatus ? state.status.schoolStatus.getColor() : DEFAULT,
  isMobile: state.ui.isMobile,
  isFullWidth: state.ui.isFullWidth,
  setupMode: state.setupMode.mode || state.setupMode.isLoading
});

export default connect(mapStateToProps, null)(AssignHub);

AssignHub.propTypes = {
  setError: PropTypes.func,
  setSuccess: PropTypes.func,
  isMobile: PropTypes.bool,
  isFullWidth: PropTypes.bool,
  statusColor: PropTypes.object,
  setupMode: PropTypes.bool.isRequired
};
